export default "__VITE_ASSET__C0SC1EOn__"